// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_botaoSair__vaAVE {
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-weight: 900 !important;
}

.styles_botaoSair__vaAVE:hover {
  background-color: #ffffff !important;
  color: #0f2047 !important;
}

.styles_menuPrincipal__HU8cr {
  background-color: #0f2047 !important;
}

.styles_cabecalhoMenuSecoes__JQ0Q\\+ {
  background-color: #0f2047 !important;
  color: #ffffff !important;
}

.styles_iconeCabecalhoMenuSecoes__O8LjR {
  color: #ffffff !important;
}

.styles_textoCabecalho__D6naw {
  font-family: "Inter" !important;
  color: #ffffff !important;
  font-size: 12px !important;
}

.styles_logoMenu__rPv3m {
  width: 120px !important;
  height: auto !important;
}

.styles_intensMenu__uh9Mr {
  font-family: "Inter" !important;
  color: #0f2047 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Main/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B","sourcesContent":[".botaoSair {\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-weight: 900 !important;\n}\n\n.botaoSair:hover {\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n}\n\n.menuPrincipal {\n  background-color: #0f2047 !important;\n}\n\n.cabecalhoMenuSecoes {\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n}\n\n.iconeCabecalhoMenuSecoes {\n  color: #ffffff !important;\n}\n\n.textoCabecalho {\n  font-family: \"Inter\" !important;\n  color: #ffffff !important;\n  font-size: 12px !important;\n}\n\n.logoMenu {\n  width: 120px !important;\n  height: auto !important;\n}\n\n.intensMenu {\n  font-family: \"Inter\" !important;\n  color: #0f2047 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoSair": `styles_botaoSair__vaAVE`,
	"menuPrincipal": `styles_menuPrincipal__HU8cr`,
	"cabecalhoMenuSecoes": `styles_cabecalhoMenuSecoes__JQ0Q+`,
	"iconeCabecalhoMenuSecoes": `styles_iconeCabecalhoMenuSecoes__O8LjR`,
	"textoCabecalho": `styles_textoCabecalho__D6naw`,
	"logoMenu": `styles_logoMenu__rPv3m`,
	"intensMenu": `styles_intensMenu__uh9Mr`
};
export default ___CSS_LOADER_EXPORT___;
